// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import lozad from 'lozad'

// Internal Dependencies:
import Animal from './Animal'
import AnimalSelected from './AnimalSelected'
import AnimalsFilters from './AnimalsFilters'
import LoadingSpinner from 'components/LoadingSpinner/LoadingSpinner'

// Redux:
import { selectedAnimal } from 'selectors/animals'
import { currentPage } from 'selectors/page'

class Animals extends React.Component {
	constructor( props ) {
		super( props )

		this.observer = lozad( '.lozad', {
			load: ( el ) => {
				el.src = el.dataset.src
				el.onload = () => {
					el.classList.add( 'lozad-loaded' )
				}
			}
		})
	}

	componentDidMount() {
		this.observer.observe()
	}

	componentDidUpdate( prevProps, prevState ) {
		this.observer.observe()
	}

	renderLoading = () => {
		return (
			<div className="-loading">
				<LoadingSpinner />
			</div>
		)
	}

	renderPagination = () => {
		const { match, location, showAdopted, animalsById, maxPages } = this.props

		if ( ! showAdopted || ! maxPages ) {
			return null
		}

		const { archivePageNumber } = match.params
		const { pathname } = location
		const pathnameNoEndSlash = pathname.replace( /\/$/, '' )

		const postsPaginationMarkup = [ ...Array( maxPages ) ].map( ( e, i ) => {
			i++
			var className = archivePageNumber == i ? 'button -page is-active' : 'button -page'
			var newPath

			if ( pathnameNoEndSlash.match( /page\/\d+/g ) ) {
				newPath = pathnameNoEndSlash.replace( /page\/\d+/g, 'page/' + i )
			} else {
				newPath = pathnameNoEndSlash + '/page/' + i
			}

			return (
				<Link to={ newPath } className={ className } key={ i }>
					{ i }
				</Link>
			)
		} )

		const postsPagination = postsPaginationMarkup.length ? (
			<div className="pagination">
				<h3>View More</h3>

				{ postsPaginationMarkup }
			</div>
		) : ''

		return postsPagination
	}

	render() {
		const { isLoading, showAdopted, animalsById, animalsType, filters, page, subpage } = this.props
		const filteredAnimalsIds = showAdopted ? this.props.filteredAdoptedAnimalsIds : this.props.filteredAnimalsIds
		let animalsMarkup = '',
			intro
		var prevAnimal
		let skipAnimalIds = []

		if ( page ) {
			intro = page.intro.rendered
		}

		if ( animalsById && Object.keys( animalsById ).length ) {
			animalsMarkup = Object.keys( animalsById )
				.filter( key => {
					if ( filteredAnimalsIds.indexOf( key ) === -1 ) {
						return false
					}

					if ( ! subpage ) {
						return true
					}

					return animalsById[ key ]['shelter'] == subpage
				})
				.map( key => {
					if ( skipAnimalIds.indexOf( key ) !== -1 ) {
						return null
					}

					let animal = animalsById[ key ],
						bondedPair = animal.bonded_pair_id ? true : false,
						showBondLeft = false,
						showBondRight = false

					if ( prevAnimal && prevAnimal.bonded_pair_id == animal.id ) {
						showBondLeft = true
					} else if ( animal.bonded_pair_id ) {
						showBondRight = true
					}

					prevAnimal = animal

					if ( animal.bonded_partner ) {
						skipAnimalIds.push( animal.bonded_partner.id )

						return [
							<Animal
								key={ animal.id }
								data={ animal }
								id={ animal.id }
								name={ animal.name }
								imageUrl={ animal.image_url }
								tagline={ animal.tagline }
								sex={ animal.sex }
								breed={ animal.breed }
								size={ animal.size }
								age={ animal.age }
								bondedPair={ bondedPair }
								showBondRight={ true }
								match={ this.props.match }
							/>,
							<Animal
								key={ animal.bonded_partner.id }
								data={ animal }
								id={ animal.bonded_partner.id }
								name={ animal.bonded_partner.name }
								imageUrl={ animal.bonded_partner.image_url }
								tagline={ animal.bonded_partner.tagline }
								sex={ animal.bonded_partner.sex }
								breed={ animal.bonded_partner.breed }
								size={ animal.bonded_partner.size }
								age={ animal.bonded_partner.age }
								bondedPair={ bondedPair }
								showBondLeft={ true }
								match={ this.props.match }
							/>
						]
					} else {
						return (
							<Animal
								key={ animal.id }
								data={ animal }
								id={ animal.id }
								name={ animal.name }
								imageUrl={ animal.image_url }
								tagline={ animal.tagline }
								sex={ animal.sex }
								breed={ animal.breed }
								size={ animal.size }
								age={ animal.age }
								bondedPair={ bondedPair }
								match={ this.props.match }
							/>
						)
					}
				})
		}

		return (
			<div className="animals">
				<AnimalsFilters subpage={ subpage } />

				{ ( showAdopted && intro ) &&
					<div id="scroll-point-animals" className="content-intro animals-intro adoptions-intro" dangerouslySetInnerHTML={ { __html: intro } } />
				|| !! intro &&
					<div className='content-intro animals-intro' dangerouslySetInnerHTML={ { __html: intro } }></div>
				}

				{ 'adopt-cats' == page.template &&
					<div className="content-intro">
						<p>
							SAFE requests that all persons adopting a cat adhere to responsible containment practices.<br />
							For more information, <Link to="/catios">click here</Link>.
						</p>
					</div>
				}

				<div className="-inner" ref={ ( e ) => { this.animalsRef = e } }>
					{ isLoading && this.renderLoading() || animalsMarkup }
				</div>

				{ this.renderPagination() }

				<AnimalSelected type={ animalsType } subpage={ subpage } match={ this.props.match } history={ this.props.history } />
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	let animalsById

	if ( state.animals.showAdopted ) {
		switch ( state.animals.animalsType ) {
			case 'cat':
				animalsById = state.animals.adoptedCatsById
				break

			case 'other':
				animalsById = state.animals.adoptedOtherById
				break

			case 'any':
				animalsById = state.animals.allAdoptedAnimalsById
				break

			default:
				animalsById = state.animals.adoptedDogsById
		}
	} else {
		switch ( state.animals.animalsType ) {
			case 'cat':
				animalsById = state.animals.catsById
				break

			case 'other':
				animalsById = state.animals.otherById
				break

			case 'any':
				animalsById = state.animals.allAnimalsById
				break

			default:
				animalsById = state.animals.dogsById
		}
	}

	return {
		isLoading: state.animals.isLoading,
		animalsById: animalsById,
		showAdopted: state.animals.showAdopted,
		maxPages: state.animals.maxPages,
		filteredAnimalsIds: state.animals.filteredAnimalsIds,
		filteredAdoptedAnimalsIds: state.animals.filteredAdoptedAnimalsIds,
		animalsType: state.animals.animalsType,
		selectedAnimal: selectedAnimal( state ),
		filters: state.animals.filters,
		page: currentPage( state )
	}
}

const mapDispatchToProps = ( dispatch, ownProps ) => {
	return {

	}
}

export default connect( mapStateToProps, mapDispatchToProps )( Animals )



// WEBPACK FOOTER //
// ./views/main/page/Animals.jsx